/**
 * External dependencies
 */
import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import $ from 'jquery';
import HiddenText from "../hidden-text/hidden-text"
import LocRatingMap from '../../components/map/loc-rating-map';
/**
 * Internal dependencies
 */
import PropertyCallout from "../property-callout/property-callout"
import PropertyIntro from "../property-intro/property-intro"
import PropertySchema from "../property-schema/property-schema"
import PropertyCalculator from "../property-calculator/property-calculator"

import Accordions from "../accordion/accordion"
import usePropertyInfo from "./use-property-info"
import "./styles/_index.scss"
import { convertGatsbyImageNodes } from "../../utils/gatsby-images"
import ContentBlock from "../content/Content";
import CalloutBanner from "../callout-banner/callout-banner";
import { pickBy, identity, isArray, get, isEmpty, isString, find } from "lodash"
import AuctionCallout from "../property-callout/auction-callout";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { currencyFormat } from "../common/utils";
// temporary data place to build UI
const data = {
  intro: {
    price: "975,000",
    street: "Old Loves Farm",
    village: "Bowerhill",
    description: "5 bedroom detached house for sale",
  },
  schema: {
    image: "",
    bullets: [
      {
        icon: "bed",
        title: "Bedrooms:",
        description: 4,
      },
      {
        icon: "bath",
        title: "Bathrooms:",
        description: 3,
      },
      {
        icon: "chair",
        title: "Reception Rooms:",
        description: "4",
      },
      {
        icon: "sheet",
        title: "Tenure:",
        description: "Freehold",
      },
      {
        icon: "house",
        title: "Property Type:",
        description: "House",
      },
    ],
  },
  features: [
    [
      "Grade II Listed Farmhouse",
      "5 Bedrooms, Bathroom & Ensuite",
      "4 Reception Rooms",
      "1.35 Acres In Total",
      "Well Maintained Gardens",
    ],
    [
      "Large Yard, Garaging, Parking",
      "Excellent Range Of Outbuildings",
      "Good Commercial Rental Opportunity",
      "Rural Setting On The Edge of Town",
    ],
  ],
  description: {
    text: `Old Loves Farm is a fabulous Grade II Listed farm house believed to date from the early/mid 18th century and set in well maintained gardens. The property has a small paddock to the rear as well as featuring a large yard with a separate access and an array of quality barns and outbuildings. Internally, the spacious well laid out interior features a good sized modern kitchen/breakfast room with 'Neff' appliances and tiled flooring, a dual aspect family room with an Inglenook fireplace and exposed beams, a study, a sitting room with an inviting log burning stove for those cold evenings and a separate dual aspect dining room. Old Loves Farm is a fabulous Grade II Listed farm house believed to date from the early/mid 18th century and set in well maintained gardens. The property has a small paddock to the rear as well as featuring a large yard with a separate access and an array of quality barns and outbuildings. Internally, the spacious well laid out interior features a good sized modern kitchen/breakfast room with 'Neff' appliances and tiled flooring, a dual aspect family room with an Inglenook fireplace and exposed beams, a study, a sitting room with an inviting log burning stove for those cold evenings and a separate dual aspect dining room.`,
  },
  accordions: [
    {
      title: "Favourite bits",
      text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
    },
    {
      title: "About the Location",
      text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
    },
    {
      title: "Important Information",
      text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
    },
  ],
  callout: {
    town: "Chippenham",
    street: "33/34 Market Place, SN15 3HP",
  },
}

const PropertyInfo = (props) => {
  const queryData = usePropertyInfo()
  const images = convertGatsbyImageNodes(queryData)
  let mapItems = [];
                let mapItem = {};
                mapItem['lat']  = props?.data?.latitude
                mapItem['lng']  = props?.data?.longitude
                mapItem['id']  = props?.data?.id
                const mapMarkerImageShowFlag = 0;
                mapItems.push( mapItem );

  // 
  const [scroll, setScroll] = useState(false)

  useEffect(() => {
      window.addEventListener("scroll", () => {
          setScroll(window.scrollY > 500)
      })
  },[])
  // 
  const GET_OFFICE_DETAIL = gql`
  query GetOfficeDetail($URL: String!) {
    offices(where: { Office_Crm_Id: $URL }) {
      id
      imagetransforms
      Office_Name
      Tail_Image {
        url
        alternativeText
      }
      Office_Address
      Office_Email
      URL
      Office_Telephone_Sales
      Office_Telephone_Lettings
      Office_Telephone_Progression
     
    }
  }
`

const { loading, error, data } = useQuery(GET_OFFICE_DETAIL, {
  variables: { URL: props?.data?.office_crm_id },
})

function createMarkup(props) {
  return {__html: (props.html)};
}

function ConvedrtHTml(props) {
  return <p dangerouslySetInnerHTML={createMarkup(props)} />;
}



const getEPCBand = (value) => {
  // A missing rating comes through the feed as 0 (or blank), not as an absent
  // node - treat anything outside the valid 1-100 score range as "not supplied"
  const score = parseInt(value, 10);
  if (isNaN(score) || score < 1 || score > 100) return null;
  if (score >= 92) return 'A';
  if (score >= 81) return 'B';
  if (score >= 69) return 'C';
  if (score >= 55) return 'D';
  if (score >= 39) return 'E';
  if (score >= 21) return 'F';
  return 'G';
};

const slicedLotData=props?.data?.extra?.lotData?.slice(2)
  return (
    <div className="property-info-wrapper">
      <Container  className="property-info">
        <Row className="flex-column flex-lg-row justify-content-lg-between">
          <Col className="property-info__content" lg="auto">
            <PropertyIntro data={props.data} />
            <PropertySchema data={props.data} />
            {isArray(props?.data?.accomadation_summary) && props?.data?.accomadation_summary?.length > 0 &&
            <div className="property-info__features pt-32 pb-32">
              <h5>Key Features</h5>

              <Row className="g-0 justify-content-lg-between">
                {props?.data?.accomadation_summary?.map((collection, index) => (
                  <Col
                    key={index}
                    xs={12}
                    lg={6}
                    className="property-info__feature-col g-0"
                  >
                      <div
                        className="property-info__feature position-relative"
                        key={index}
                      >
                        <ConvedrtHTml html={collection} />
                      </div>
                  </Col>
                ))
                // : 
                // <ContentBlock Content={props?.data?.accomadation_summary} />
                }
              </Row>
            </div>
            }

            <HiddenText
              title="Property Description"
              text={props?.data?.long_description}
              lotData={slicedLotData}
              department={props?.data?.department}
            />
            {props.data?.department !== "auction" && <section className="material-info pt-32 pb-32 has-overlay">
              <Container>
                <h3 className="title">Material Information</h3>

                <Row>
                  <Col md={4}>
                    <div className="material-item">
                      <span className="label">Price:</span>
                      <span className="value">
                        {props?.data?.price ? `${currencyFormat(props?.data?.price , '£', false)}` : 'Ask Agent'}
                      </span>
                    </div>

                    <div className="material-item">
                      <span className="label">Total Sq Ft:</span>
                      <span className="value">{props?.data?.total_sqftss || 'Ask Agent'}</span>
                    </div>

                    <div className="material-item">
                      <span className="label">Broadband:</span>
                      <span className="value">{props?.data?.broadbandss || 'Ask Agent'}</span>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="material-item">
                      <span className="label">Property Type:</span>
                      <span className="value"> {props?.data?.building
                      ? props.data.building.charAt(0).toUpperCase() +
                        props.data.building.slice(1)
                      : 'Ask Agent'}</span>
                          </div>

                    <div className="material-item">
                      <span className="label">Council tax band:</span>
                      <span className="value">
                        {props?.data?.utilities?.council_tax?.value ? `Band ${props?.data?.utilities?.council_tax?.value}` : 'Ask Agent'}
                      </span>
                    </div>

                    <div className="material-item">
                      <span className="label">Parking:</span>
                      <span className="value">{props?.data?.parking_type || 'Ask Agent'}</span>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="material-item">
                      <span className="label">Tenure:</span>
                      <span className="value">
                        {props?.data?.utilities?.tenure?.value === "1" ? 'Freehold' : 
                        props?.data?.utilities?.tenure?.value === "2" ? 'Leasehold' : 'Ask Agent'}
                      </span>
                    </div>

                    <div className="material-item">
                      <span className="label">EPC:</span>
                      <span className="value">{getEPCBand(props?.data?.utilities?.hip?.energy_performance?.energy_efficiency?.current?.value) || 'Ask Agent'}</span>
                    </div>

                    <div className="material-item">
                      <span className="label">Heating:</span>
                      <span className="value">{props?.data?.heating|| 'Ask Agent'}</span>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>}

{/* 
{isArray(props?.data?.extra?.lotData) && props?.data?.extra?.lotData?.length > 0 &&
            <div className='margin-top-15-fix'>
                {props?.data?.extra?.lotData?.map((collection, index) => (
                      collection.ID !== 0 ?
                      <div
                        key={index}
                      >
                                      <h5>{collection.Name}</h5>

                        <ContentBlock Content={collection.Value} />
                      </div>
                : null
                ))
                }
             
            </div>
            } */}


            {/* <Accordions>
              {data.accordions.map((x, index) => (
                <Accordions.Item key={x.title} eventKey={index} title={x.title}>
                  <p>{x.text}</p>
                </Accordions.Item>
              ))}
            </Accordions> */}
            {props.data?.department !== "auction" &&
            <div className="d-lg-none">
              <div className="property-info__callout">
                <PropertyCallout
                  data={props.data}
                />
              </div>
            </div>}

            {props?.data?.latitude && props?.data?.longitude &&
            <div className="property-details-landing-map my-5" id="property-details-map">
                <LocRatingMap data={mapItems} hasTitle={true} />
            </div>
            }
            {props.data?.search_type === "sales" && props.data?.department !== "auction" &&
            <>
              <PropertyCalculator data={props.data} search_type={props.data?.search_type} price={props.data?.price}
              office={data?.offices[0]?.Office_Name}
              />
              <div className="border-bottom d-none d-md-block mb-4_0"></div>
              </>
            }
           {props.data?.department !== "auction" &&
            <CalloutBanner addShell={false} title={"removals"}
              subTitle={"Moving house and need a removal service?"}
              description={"We work with great removal companies. Get in touch to find out more."}
              linkHref={{"Alias": "removals"}}
              // Link_Type={"Internal"}
              // linkText={"Click to find out more"} 
              isForm={true}
              data={props.data} 
              search_type={props.data?.search_type}
              price={props.data?.price}
              office={data?.offices[0]?.Office_Name}
              // to_admin={data?.offices[0]?.Office_Email?.toLowerCase()}
              to_admin="strakers@phillipsremovals.com"
            />}
          </Col>

          <Col className={`property-info__callout ${props.data?.department === "auction" ? "d-block" : "d-lg-block d-none"} `} lg={props.data?.department === "auction" ? "4" : "auto"}>
            <div className={`sticky-top ${scroll ? "scrolled" : ""}`}>
              {props.data?.department === "auction" ?
                            <AuctionCallout
                            data={props.data}
                          />
              :
              <PropertyCallout
                data={props.data}
              />}
            </div>
          </Col>
        </Row>

        {/* <PropertyCalculator price={props.data?.price} />
        <CalloutBanner addShell={false} title={"removals"}
                    subTitle={"Moving house and need a removal service??"}
                    description={"Lorem ipsum dolor sit ame consectetur adipiscing elit."}
                    linkHref={data?.glstrapi?.newsBanner?.Link}
                    linkText={"Click to find out more"} /> */}
      </Container>
    </div>
  )
}

export default PropertyInfo
